export const isIpad = screenWidth => {
  return screenWidth >= 768 && screenWidth <= 1024;
};